/* eslint-disable no-unused-expressions */
/* eslint-disable no-shadow */
/* eslint-disable react/require-default-props */
import React, { Key, useState } from 'react';
import { Tree, Skeleton } from 'antd';
import { FolderOutlined, FolderOpenFilled, MinusSquareOutlined, PlusSquareOutlined } from '@ant-design/icons';
import { schoolTypeCodeOption } from 'constants/optionCommon';
import { buildTreeData_QuestionType } from '../functions';
import { QuestionTypeData } from '../type';

type Props = {
  allData?: QuestionTypeData[];
  onSelect: Function;
  schoolType: string;
  selectedKeys?: Key[];
};

const TreeViewData = ({ allData, onSelect, schoolType, selectedKeys }: Props) => {
  const [expandedStatus, setExpandedStatus] = useState('expandAll');
  const [expandedKeys, setExpandedKeys] = useState([]);

  const filterArr: QuestionTypeData[] = allData?.filter((i) => i.schoolType === schoolType) ?? [];
  const treeFolder = buildTreeData_QuestionType(filterArr);
  const treeTitle = schoolTypeCodeOption.find((i) => i.value === schoolType)?.label ?? '';

  // ColapseAll or ExpandAll tree folder
  const handleExpandOrCollapseAll = (type: string) => {
    if (type === 'expandAll') {
      setExpandedStatus('collapseAll');
      const keys: string[] = filterArr.map((i) => i.id);
      setExpandedKeys(keys);
    } else if (type === 'collapseAll') {
      setExpandedStatus('expandAll');
      setExpandedKeys([]);
    }
  };
  // when select folder
  const handleExpand = (expandedKeys: any[]) => {
    setExpandedKeys(expandedKeys);
  };

  return (
    <React.Fragment>
      <Skeleton active loading={!allData}>
        <h2>{treeTitle}</h2>
        <div
          style={{
            overflowY: 'auto',
            minHeight: 'calc(100vh - 300px)',
            maxHeight: 'calc(100vh - 100px)',
            height: 'calc( 100% - 38px) ',
            display: 'flex',
            justifyContent: 'space-between',
            border: '1px dashed #333',
            borderRadius: 5,
            padding: '10px 5px',
          }}
        >
          {filterArr?.length > 0 && (
            <Tree.DirectoryTree
              icon={(props: any) => {
                return (
                  <React.Fragment>
                    {props.selected ? <FolderOpenFilled className='tw-mr-1' style={{ color: props.data.color, fontSize: 16 }} /> : <FolderOutlined className='tw-mr-1' style={{ color: props.data.color, fontSize: 16 }} />}
                  </React.Fragment>
                );
              }}
              multiple={false}
              expandedKeys={expandedKeys} // colapseAll
              onExpand={handleExpand}
              onSelect={(newSelectedKeys, info) => {
                if (selectedKeys.includes(newSelectedKeys?.[0])) {
                  onSelect(null);
                } else {
                  onSelect(info.node);
                }
              }}
              selectedKeys={selectedKeys}
              treeData={treeFolder}
            />
          )}

          {filterArr?.length > 1 ? (
            <div style={{ padding: '0 5px' }}>
              {expandedStatus === 'collapseAll' ? <MinusSquareOutlined onClick={() => handleExpandOrCollapseAll(expandedStatus)} /> : <PlusSquareOutlined onClick={() => handleExpandOrCollapseAll(expandedStatus)} />}
            </div>
          ) : null}
        </div>
      </Skeleton>
    </React.Fragment>
  );
};

export default TreeViewData;
